export default __webpack_public_path__ + "static/media/vd-screenshot-facts.7c9060d6.png";